import { render, staticRenderFns } from "./ansDistributionToRegList.vue?vue&type=template&id=66b9cf76&"
import script from "./ansDistributionToRegList.vue?vue&type=script&lang=js&"
export * from "./ansDistributionToRegList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports